import axios from 'src/api/Api';
import {
    CONSIGNED_INVENTORY_EXPORT_SUCCESS,
    CONSIGNED_INVENTORY_EXPORT_FAILURE,
} from '../actions';

import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const normalizeConsignedExportParams = (payload = {}) => {
    const params = payload || {};
    return {
        ...params,
        'item description':
            params['item description'] ??
            params.itemDescription,
        'item number':
            params['item number'] ??
            params.itemNumber,
    };
};

const buildQueryString = (params) =>
    Object.entries(params)
        .filter(
            ([key, value]) =>
                key !== 'itemDescription' &&
                key !== 'itemNumber' &&
                value !== undefined &&
                value !== null &&
                value !== ''
        )
        .map(
            ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&');

export const buildConsignedInventoryExportUrl = (baseSiteId, payload) => {
    const queryString = buildQueryString(normalizeConsignedExportParams(payload));
    const baseUrl = `occ/v2/${baseSiteId}/consignment/inventory/export`;

    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export default function* consignedInventoryExport(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = buildConsignedInventoryExportUrl(baseSiteId, action.payload);

    try {
        const result = yield axios.get(url, { responseType: 'blob' }).then((response) => response.data);
        yield put({
            type: CONSIGNED_INVENTORY_EXPORT_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });
        yield put({
            type: CONSIGNED_INVENTORY_EXPORT_FAILURE,
            payload: { error: errorHandler('503') },
        });
    }
}
